import { render, staticRenderFns } from "./BookingReportPassengerView.vue?vue&type=template&id=673205ed&"
import script from "./BookingReportPassengerView.vue?vue&type=script&lang=js&"
export * from "./BookingReportPassengerView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('673205ed')) {
      api.createRecord('673205ed', component.options)
    } else {
      api.reload('673205ed', component.options)
    }
    module.hot.accept("./BookingReportPassengerView.vue?vue&type=template&id=673205ed&", function () {
      api.rerender('673205ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/booking/report/BookingReportPassengerView.vue"
export default component.exports